module.exports = __webpack_public_path__ + "static/media/flight_checkin_icon.4581f015.svg";